import React from 'react';
import PropTypes from 'prop-types';
import { RightOutlined } from '@ant-design/icons';
import { numberWithCommas } from 'utils/NumberCommaSeprator';
import { MarginCell, NoHoverTable, NumCell } from './warehousingStyles';

const money = (value) =>
	value === null || value === undefined ? '—' : `₹ ${numberWithCommas(Math.round(value))}`;

const sortByNumber = (key) => (a, b) => (Number(a[key]) || 0) - (Number(b[key]) || 0);

/**
 * Portfolio project rows.
 *
 * Columns are limited to what the portfolio response actually carries — it returns
 * project identity and figures, but no client name, revenue model or last-updated
 * timestamp, so those columns from the original mock are not rendered.
 */
export default function WarehouseProjectsTable({ projects, loading, onRowClick }) {
	const columns = [
		{
			title: 'Project',
			dataIndex: 'project_name',
			key: 'project_name',
			sorter: (a, b) => (a.project_name || '').localeCompare(b.project_name || ''),
			render: (value) => value || '—',
		},
		{
			title: 'Project Code',
			dataIndex: 'project_code',
			key: 'project_code',
			render: (value) => value || '—',
		},
		{
			title: 'MTD Shipments',
			dataIndex: 'shipment_count',
			key: 'shipment_count',
			align: 'right',
			sorter: sortByNumber('shipment_count'),
			render: (value) => <NumCell>{numberWithCommas(value || 0)}</NumCell>,
		},
		{
			title: 'MTD Revenue',
			dataIndex: 'customer_revenue',
			key: 'customer_revenue',
			align: 'right',
			sorter: sortByNumber('customer_revenue'),
			render: (value) => <NumCell>{money(value)}</NumCell>,
		},
		{
			title: 'MTD Cost',
			dataIndex: 'customer_cost',
			key: 'customer_cost',
			align: 'right',
			sorter: sortByNumber('customer_cost'),
			render: (value) => <NumCell>{money(value)}</NumCell>,
		},
		{
			title: 'Margin %',
			dataIndex: 'customer_margin_pct',
			key: 'customer_margin_pct',
			align: 'right',
			sorter: sortByNumber('customer_margin_pct'),
			render: (value) => {
				if (value === null || value === undefined) return <NumCell>—</NumCell>;
				return (
					<MarginCell negative={Number(value) < 0}>
						{Number(value).toFixed(1)}%
					</MarginCell>
				);
			},
		},
		{
			title: '',
			key: 'chevron',
			width: 48,
			align: 'center',
			render: () => <RightOutlined style={{ color: '#8c8c8c' }} />,
		},
	];

	return (
		<NoHoverTable
			rowKey="project_id"
			columns={columns}
			dataSource={projects}
			loading={loading}
			pagination={false}
			scroll={{ x: 900 }}
			onRow={(record) => ({
				onClick: () => onRowClick(record),
				style: { cursor: 'pointer' },
			})}
		/>
	);
}

WarehouseProjectsTable.propTypes = {
	projects: PropTypes.array,
	loading: PropTypes.bool,
	onRowClick: PropTypes.func.isRequired,
};

WarehouseProjectsTable.defaultProps = {
	projects: [],
	loading: false,
};
